module.exports = __webpack_public_path__ + "fonts/Roboto-400-latin39.665db5e.woff2";